// iOS Safari 17+ (`navigator.audioSession`): what kind of audio the page makes. With no mic
// open, Web Audio defaults to "ambient", which the ringer switch mutes; replies to a typed
// turn are "playback" so they're heard. Opening the mic goes back to "auto" (Safari picks
// play-and-record), or the capture could be refused. Elsewhere this does nothing.

export type AudioSessionType = "auto" | "playback" | "play-and-record" | "ambient" | "transient" | "transient-solo";

export function setAudioSession(type: AudioSessionType, nav: unknown = typeof navigator !== "undefined" ? navigator : undefined): void {
  const session = (nav as { audioSession?: { type: string } } | undefined)?.audioSession;
  if (!session) return;
  try {
    if (session.type !== type) session.type = type;
  } catch {
    /* refused (e.g. while the mic is live): keep the current kind */
  }
}
